<app-stages [stages]="stages" currentStage="Charakterystyka inwestycji"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class="col-12">
        <div class='form-group' *ngIf='"investmentNameAndTotalObjects" as controlName'>
          <label [for]='controlName'>
            Nazwa inwestycji oraz łączna ilość obiektów *
          </label>
          <textarea
            rows="2"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu nazwę inwestycji oraz łączną ilość obiektów'>
            </textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <fieldset>
      <legend>
        Parametry dotyczące terenu inwestycji
      </legend>
      <div class="row">
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"maxBuildingHeight" as controlName'>
            <label [for]='controlName'>
              Wysokość <br> całkowita obiektu (cm)
            </label>
            <input
              mask="separator.2"
              decimalMarker=","
              thousandSeparator=""
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu wysokość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"width" as controlName'>
            <label [for]='controlName'>
              Szerokość <br> obiektu (cm)
            </label>
            <input
              mask="separator.2"
              decimalMarker=","
              thousandSeparator=""
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu szerokość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"thickness" as controlName'>
            <label [for]='controlName'>
              Grubość <br> obiektu (cm)
            </label>
            <input
              mask="separator.2"
              decimalMarker=","
              thousandSeparator=""
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu grubość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"area" as controlName'>
            <label [for]='controlName'>
              Powierzchnia <br> ekspozycji wymiary (cm<sup>2</sup>)
            </label>
            <input
              mask="separator.2"
              decimalMarker=","
              thousandSeparator=""
              [dropSpecialCharacters]="false"
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu grubość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-5'>
          <div class='form-group' *ngIf='"height" as controlName'>
            <label [for]='controlName'>
              Wysokość dolnej krawędzi powierzchni ekspozycji od <br> poziomu terenu (cm)
            </label>
            <input
              mask="separator.2"
              decimalMarker=","
              thousandSeparator=""
              [dropSpecialCharacters]="false"
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu wysokość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"distance" as controlName'>
            <label [for]='controlName'>
              Odległość od <br> najbliższego budynku (cm)
            </label>
            <input
              mask="separator.2"
              decimalMarker=","
              thousandSeparator=""
              [dropSpecialCharacters]="false"
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu odległość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"groundMountingMethod" as controlName'>
            <label [for]='controlName'>
              Sposób montażu do gruntu/na elewacji/w witrynie *
            </label>
            <textarea
              rows="2"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu sposób montażu do gruntu/na elewacji/w witrynie'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-12">
          <div class='form-group' *ngIf='"buildingMaterialsAndColor" as controlName'>
            <label [for]='controlName'>
              Materiały budowlane z jakich wykonany jest obiekt oraz jego kolor *
            </label>
            <textarea
              rows="2"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu materiały z jakich wykonany jest obiekt oraz jego kolor'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-12">
          <div class='form-group' *ngIf='"electricityAccessDescription" as controlName'>
            <label [for]='controlName'>
              Dostęp do energii elektrycznej *
            </label>
            <textarea
              rows="2"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Opisz tu'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Łączna powierzchnia sprzedaży/użytkowa w metrach kwadratowych, w przypadku gdy inwestycja towarzyszy
        wolnostojącym obiektom handlowym/gastronomicznym
      </legend>
      <div class='col-md-3'>
        <div class='form-group' *ngIf='"totalSalesOrUsableArea" as controlName'>
          <label [for]='controlName'>
            Łączna powierzchnia (m<sup>2</sup>) *
          </label>
          <input
            mask="separator.2"
            decimalMarker=","
            thousandSeparator=""
            [dropSpecialCharacters]="false"
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu łączną powierzchnie'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </fieldset>
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
